import { useTranslation } from 'react-i18next';
import styles from '../../Components/Bookings/Bookings.module.css';
import CartItem from '../../Components/Cart/CartItem';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCarts } from '../../redux/Slices/Cart/thunk';
import { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from 'react-bootstrap';
import {paymentStatus, EmptyPaymentStatus} from '../../redux/Slices/payment/thunk'
import { parse } from 'date-fns'; 
import notify from '../../Components/Utilities/notify';
import { useSearchParams } from 'react-router-dom';


export default function CartPage() {
  const { t, i18n } = useTranslation();
  const navigate=useNavigate();
  const dispatch = useDispatch();
  const {Carts, loading} = useSelector((state) => state.cartsSlice)  
  const paymentStatusResponse = useSelector((state) => state.paymentSlice.paymentStatusResponse);
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("paymentId");
  const invoiceId = localStorage.getItem('invoiceId');
  const user = JSON.parse(localStorage.getItem('user'));
    const [showFailureModal, setShowFailureModal] = useState(false);

  useEffect(()=>{
    if(paymentId || invoiceId){
      const statusData = { key: paymentId || invoiceId,
        //  isTest:true
         };
      dispatch(paymentStatus({ data: statusData }));
    }

    dispatch(getCarts({id:user?.cln_key}))

    return () => {
      localStorage.removeItem("reservationPackageData");
      localStorage.removeItem("reservationData");
      localStorage.removeItem("PaymentURL");
      localStorage.removeItem("invoiceId");
    }
  },[])

  useEffect(() => {
    if (paymentStatusResponse) {
      const invoiceStatus = paymentStatusResponse?.Data?.InvoiceStatus;
      if (invoiceStatus && invoiceStatus !== "Paid") {
        setShowFailureModal(true);
      }
      dispatch(EmptyPaymentStatus());
    }
  }, [paymentStatusResponse, dispatch]);
  console.log("Carts",Carts)

  const totalPrice = Carts?.reduce((sum, cart) => {
    const price = parseFloat(cart.itm_price?.trim()) || 0; // Ensure valid number
    return sum + price;
  }, 0);


  const handlePay = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    const isValid = Carts.every((cart) => {
      const cartDateString = cart.date.trim(); 
      const cartDate = new Date(cartDateString);
      cartDate.setHours(0, 0, 0, 0); 
  
      return cartDate >= today;
    });
    console.log("isValid",isValid)
  
    if (!isValid) {
      notify(t('cannot_book_past_date'),"error");
      return;
    }
  
    navigate('/checkout', { state: { Carts } });
  };
  
  return (
    <div className='flex-grow-1'>
  {loading ? <div style={{display:"flex", justifyContent:"center"}}>

<Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
</div> : 
<div>
   
    {Carts && Carts.length > 0 ? <div className='container'>
      <div className={styles.loginContainer}>
        <div className={`${styles.loginHeader} my-3`}>{t("cart")}</div>

     { Carts &&  <CartItem Carts={Carts} />}

        { <div className={styles.box_total} style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
         <div><span> {t('Total')} :  </span> <span> <span>{totalPrice.toFixed(2)}</span> <span> {t('rs')} </span></span></div>
         <div style={{textDecoration:"underline", color:"#001ab3", cursor:"pointer"}} onClick={()=>navigate('/categories')}>حجز خدمه اخري</div>
        </div>}

        <div className={`${styles.submitContainer} ${styles.submitContainerMaxWidth} ${styles.submitContainerMaxWidth1400}`} style={{margin:"0 auto 15px auto"}}>
        <div className={styles.onSubmit} onClick={handlePay}>
  {t("Pay")}
</div>

        </div>

      </div>

    </div> :  <div style={{
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      fontSize:"28px",
      fontWeight:"900",
      margin:"70px"
    }}>{t('no_services_in_cart')} </div> }
      <Modal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        centered
      >
        <Modal.Body className="text-center p-5">
          <div>
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              className="checkmark"
              style={{ fill: "none", stroke: "#F0142F", strokeWidth: 8 }}
            >
              <circle cx="40" cy="40" r="35" strokeOpacity="0.2" />
              <path
                d="M25 25 L55 55 M55 25 L25 55"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h4
            className="mt-4 mb-3"
            style={{ color: "#F0142F", fontWeight: 600 }}
          >
            {t("payment.failed")}
          </h4>
        </Modal.Body>
      </Modal>
    </div>}
    </div>
  )
}
